// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"4c45cb67","129":"2e12668c","197":"b207004f","618":"17f8f26d","725":"89628289","992":"0879da79"}[chunkId] + ".chunk.js";
};